// @core/api/endpoints/billing/update_account.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateAccountRequest,
  UpdateAccountResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Update account
 * Updates an existing account's metadata such as name and description. Account type and code cannot be changed after creation.
 */
export async function UpdateAccount(
  id: string,
  data: UpdateAccountRequest,
  options?: RequestOptions
): Promise<UpdateAccountResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/accounts/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.patch<UpdateAccountResponse>(requestPath, data, requestOptions);
}
